import { render, staticRenderFns } from "./RectangleElement.vue?vue&type=template&id=5ffc7c32&scoped=true&"
import script from "./RectangleElement.vue?vue&type=script&lang=js&"
export * from "./RectangleElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc7c32",
  null
  
)

export default component.exports